<template>
  <SlideSidebarContainer>
    <template v-slot:title>
      Timeline
    </template>

    <template v-slot:subtitle>
      Evolução em tempo real dos #cyberStudents
    </template>

    <TimelineActivities />
  </SlideSidebarContainer>
</template>

<script>
  import TimelineActivities from '@/components/timeline/TimelineActivities.vue'
  import SlideSidebarContainer from '@/components/layout/sidebars/SlideSidebarContainer'

  export default {
    components: {
      TimelineActivities,
      SlideSidebarContainer,
    }
  }
</script>